import { useEffect, useMemo, useState } from "react";
import { FormDataConsumer, RadioButtonGroupInput, required, SaveButton, SimpleForm, Toolbar } from "react-admin";
import { FieldValues, SubmitHandler, useFormContext } from "react-hook-form";
import { CustomRadioInputProps, InitialFormValuesProps, JboxTypeEnum } from "./types";
import TriggerDagForm from "./TriggerDagForm";
import { enumToChoices } from "shared/utils/reactAdminHelpers";

const CustomToolbar = ({ disabled }: { disabled: boolean }) => {
  return (
    <Toolbar>
      <SaveButton label="load form" disabled={disabled} />
    </Toolbar>
  );
};

export default function GenerationInitialForm() {
  const [initalFormValues, setInitalFormValues] = useState<InitialFormValuesProps | null>(null);
  const [disabled, setDisabled] = useState(false);
  const handleSubmit: SubmitHandler<FieldValues> = (values) => {
    setInitalFormValues(values as any);
    setDisabled(true);
  };
  const resetForm = () => {
    setInitalFormValues(null);
    setDisabled(false);
  };

  const jboxTypeChoices = useMemo(() => enumToChoices(JboxTypeEnum), []);

  return (
    <>
      <SimpleForm toolbar={<CustomToolbar disabled={disabled} />} onSubmit={handleSubmit}>
        <RadioButtonGroupInput
          source="jbox_type"
          parse={(value) => +value}
          validate={required()}
          disabled={disabled}
          choices={jboxTypeChoices}
        />

        <FormDataConsumer>
          {({ formData }) => {
            return <CustomRadioInput formData={formData} disabled={disabled} />;
          }}
        </FormDataConsumer>
      </SimpleForm>
      {initalFormValues && <TriggerDagForm initialFormValues={initalFormValues} resetForm={resetForm} />}
    </>
  );
}

const CustomRadioInput = ({ formData, disabled }: CustomRadioInputProps) => {
  const { setValue } = useFormContext();
  const inputDisabled = disabled || !formData.jbox_type;
  const isJbox1 = formData.jbox_type === 1;
  const choices = [{ id: "MSI", name: "MSI" }];
  if (isJbox1) {
    choices.push({ id: "Performance", name: "Performance" });
  }
  useEffect(() => {
    if (formData.jbox_type === 2) {
      setValue("chronicle_type", "MSI");
    }
  }, [setValue, formData.jbox_type]);
  return (
    <RadioButtonGroupInput disabled={inputDisabled} source="chronicle_type" validate={required()} choices={choices} />
  );
};
